import React from 'react';

const Timer = ({ time, tryAgainEv }) => {
  // Calculate minutes and seconds
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  return (
    <div className="tab">
      <div className="" onClick={tryAgainEv}>
        {time > 0 ? (
          <div className="timer">
            <div className="timestamp">
              {minutes}
              <small>minutes</small>
            </div> 
            <span className='column'>:</span>
            <div className="timestamp">
              {seconds}
              <small>seconds</small>
            </div>
          </div>
        ) : (
          <small className="tryAgn">Try Again</small>
        )}
      </div>
    </div>
  );
};

export default Timer;
